export const search_types = {
  PRODUCT: "Product",
  PROVIDER: "Provider",
  CATEGORY: "Category",
};
